module.exports = __webpack_public_path__ + "static/media/socket_tongue.48f66b31.webp";